import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getGroupServerList } from "@/api/gmToolNew/gmToolNew";
import addserver from "./components/addserver.vue";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  name: "groupServer",
  components: {
    addserver: addserver
  },
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      prizeList: [],
      dialog: false,
      total: 0,
      list: [],
      paramsData: {},
      SelectionList: []
    };
  },
  created: function created() {// this.getList()

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  watch: {
    "paramsData.env_id": function paramsDataEnv_id() {
      this.list = [];
    },
    serverChannel: {
      handler: function handler(val) {
        if (val && val.length > 0 && !this.server_channel) {
          this.server_channel = val[0].value;
        }
      },
      immediate: true
    }
  },
  methods: {
    // 关闭弹窗
    changeShow: function changeShow(val) {
      this.dialog = val;
    },
    getList: function getList() {
      var _this = this;

      this.reqLoading = true;

      if (this.paramsData) {
        this.paramsData.server_id = '';
      }

      if (this.searchData) {
        this.searchData.server_id = '';
      }

      getGroupServerList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        server_channel: this.server_channel
      })).then(function (res) {
        if (res.status == 200) {
          var resData = res.data || [];
          _this.list = resData.map(function (item) {
            item.channels = item.channels.toString();
            item.server_ids = item.server_ids.toString();
            return item;
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    }
  }
};